/**
 * Marks that this tab already decided which organization to land in, so the account-selection
 * screen (shown to people with two or more direct memberships) does not reappear on every visit
 * to the dashboard route within the same tab session.
 */
export const ACCOUNT_ENTRY_ACKNOWLEDGED_KEY = 'account_entryAcknowledged';

/**
 * localStorage key holding the board URL (path + query) saved right before an account switch
 * away from it, with the master account it belongs to, so "back to the board" restores period/filter/position
 * rather than landing on an unfiltered client list. Read and written only through
 * `utils/master-account-board-return`.
 */
export const MASTER_ACCOUNT_BOARD_RETURN_URL_KEY = 'master_account_boardReturnUrl';
